import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { NotificationManager } from 'react-notifications';
import { useMsal } from '@azure/msal-react';
import useFetchSensorPurchaseOrders from './useFetchSensorPurchaseOrders';
import { msalConfig } from '../auth/authConfig';
import { errorHandler } from '../utils/helpers';
import useUserStore from '../store/userStore';
import { acquireToken } from '../utils/auth';

interface DeleteSensorPurchaseOrderRequest {
  id: string | number;
  token: string | null;
  setError: (data: any) => any;
  setLoading: (data: any) => any;
  fetchSensorPurchaseOrders: () => any;
  userId: string | number;
};

const deleteSensorPurchaseOrderRequest = async ({
    token,
    setError,
    setLoading,
    fetchSensorPurchaseOrders,
    id,
    userId,
  }: DeleteSensorPurchaseOrderRequest) => {
  try {
    const response = await axios.delete(`${window.__env.REACT_APP_API_URL || process.env.REACT_APP_API_URL}/Sensor/PurchaseOrder/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json, text/plain, */*',
        userId,
      },
    });
    if (response.status === 200) {
      NotificationManager.success('Sensor Purchase Order successfully deleted');
    }
  } catch (error) {
    errorHandler(error, setError);
  } finally {
    fetchSensorPurchaseOrders();
    setLoading(false);
  }
};

interface DeleteSensorPurchaseOrder {
  deleteSensorPurchaseOrder: (id: string | number) => void;
  loading: boolean;
  error: Error | null;
};

const useDeleteSensorPurchaseOrder = (): DeleteSensorPurchaseOrder => {
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);
  const { fetchSensorPurchaseOrders } = useFetchSensorPurchaseOrders();
  
  const { user } = useUserStore();

  const deleteSensorPurchaseOrder = async (id) => {
    if (accounts.length > 0) {
      const accessTokenRequest = {
        scopes: [`${msalConfig.auth.clientId}/.default`],
        account: accounts[0],
      };

      if (!user) return navigate('/sign-in');

      try {
        const accessToken = await acquireToken(instance, accessTokenRequest);
        deleteSensorPurchaseOrderRequest({
          id,
          token: accessToken,
          setError,
          fetchSensorPurchaseOrders,
          setLoading,
          userId: user.id,
        });
      } catch (error) {
        errorHandler(error, setError);
      }
    } else {
      navigate('/sign-in');
    }
  }

  return { deleteSensorPurchaseOrder, loading, error };
};

export default useDeleteSensorPurchaseOrder;
